import axios from "axios";
import { createAuthRefreshHandler } from "./authRefresh";

// Every API call must include cookies so the httpOnly auth cookies
// (access_token, session_token) travel with the request.
axios.defaults.withCredentials = true;

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// NP-2 — sign-in expiry recovery. A 401 triggers one POST /auth/refresh
// and one retry of the original request (see lib/authRefresh.js). If the
// refresh fails, listeners registered with onSessionExpired() are told.
const expiredListeners = new Set();
export function onSessionExpired(listener) {
  expiredListeners.add(listener);
  return () => expiredListeners.delete(listener);
}
if (!axios.__tgAuthRefreshInstalled) {
  axios.__tgAuthRefreshInstalled = true;
  axios.interceptors.response.use(
    (response) => response,
    createAuthRefreshHandler({
      retry: (config) => axios(config),
      refresh: () => axios.post(`${API_BASE}/auth/refresh`, null, { skipAuthRefresh: true }),
      onExpired: () => expiredListeners.forEach((listener) => listener()),
    })
  );
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default axios;
